"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPriceCountryMapper = void 0;
/**
 * Mapper that is used to convert the price country property from a shopping cart session.
 */
class ShopPriceCountryMapper {
    /**
     * Converts the price country from a shopping cart session to an alpha-2 country code.
     *
     * @param priceCountry The price country property.
     */
    static toAlpha2CountryCode(priceCountry) {
        return priceCountry.toUpperCase().replace(/^UK$/, 'GB');
    }
}
exports.ShopPriceCountryMapper = ShopPriceCountryMapper;
//# sourceMappingURL=ShopPriceCountryMapper.js.map